// /src/applyBrandTheme.js
import BRAND from './brand';

export default function applyBrandTheme() {
  if (!BRAND || BRAND.name !== 'Horizon') return;

  const root = document.documentElement;

  // ✅ Turn Horizon ON
  root.setAttribute('data-brand', 'horizon');

  // ✅ Load Roboto
  const { googleFontUrl } = BRAND.theme.typography;

  if (googleFontUrl) {
    const existing = document.querySelector('link[data-horizon-font]');
    if (!existing) {
      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = googleFontUrl;
      link.setAttribute('data-horizon-font', 'true');
      document.head.appendChild(link);
    }
  }
}

